import { EmployeePortalContent } from './EmployeePortalContent';
import EmployeeDataProvider from './Show/EmployeeDataProvider';

const EmployeePortal = () => {
  return (
    <EmployeeDataProvider>
      <EmployeePortalContent />
    </EmployeeDataProvider>
  );
};

export default EmployeePortal;
